<template>
  <div class="chatContentBox">
    <div class="chatBox" ref="chatBox">
      <ul class="clearfix" ref="chatListBox">
        <li
          v-for="(item, index) in chatBox"
          :key="index"
          :class="[item.from == customerid ? 'right' : 'left']"
        >
          <div class="chatDetail">
            <div
              class="img"
              v-if="item.from != customerid"
              :style="{
                'background-image': 'url(' + item.avatar + ')',
              }"
            ></div>
            <div class="content">
              <div>
                <p class="name">
                  {{ item.nick }}
                </p>
                <div class="messageContent" v-if="item.payload">
                  {{ item.payload.text }}
                </div>
              </div>
            </div>
            <div
              class="img"
              v-if="item.from == customerid"
              :style="{
                'background-image': 'url(' + item.avatar + ')',
              }"
            ></div>
          </div>
        </li>
      </ul>
    </div>
    <div class="footerBox">
      <div class="sendMsg">
        <div class="sendLeft">
          <form
            action="/"
            method="get"
            enctype="application/json"
            @submit.prevent="sendMsg"
          >
            <input
              type="text"
              v-model="message"
              placeholder="输入你需要提的问题"
              @mouseup.prevent
              ref="inputMsg"
              @blur="onblur"
            />
          </form>
        </div>
        <div class="sendRight">
          <span class="send" @click="sendMsg">发送</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TIM from "tim-js-sdk";
export default {
  metaInfo() {
    return {
      title: this.name,
    };
  },

  data() {
    return {
      info: "",
      message: "",
      chatBox: [],
      tim: "",
      loginTim: false,
      name: "",
      userid: "",
      userinfo: "",
      customerid: "",
    };
  },
  components: {},
  mounted() {
    var _this = this;
    this.name = this.$route.query.name ? this.$route.query.name : "";
    this.userid = this.$route.query.userid ? this.$route.query.userid : "";
    this.userinfo = JSON.parse(
      JSON.stringify(_this.$store.state.state.userinfo)
    );
    this.customerid = this.userinfo.customerid;
    this.getIm();
  },
  methods: {
    srollEvent() {
      var _this = this;
      var scroll = _this.$refs.chatBox.scrollTop;
      if (scroll <= 0 && !this.end) {
        this.ScrollHeight = this.$refs.chatBox.scrollHeight;
        if (this.timReady) {
          this.getMessge(1);
        }
      }
    },
    getIm() {
      this.$post("/iart-api-message/im/queryAppid", {}).then((res) => {
        if (res.code == 1) {
          var options = {
            SDKAppID: res.data.appid - 0, // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
          };
          // 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
          this.tim = TIM.create(options);
          // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
          this.tim.setLogLevel(1);
          //监听消息回调
          this.login();
          this.onTim();
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    onTim() {
      var _this = this;
      var onKickedOut = function (event) {
        // TIM.TYPES.KICKED_OUT_MULT_ACCOUNT(Web端，同一账号，多页面登录被踢)
        // TIM.TYPES.KICKED_OUT_MULT_DEVICE(同一账号，多端登录被踢)
        // TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED(签名过期。使用前需要将SDK版本升级至v2.4.0或以上)
        if (localStorage.getItem("isWeixin") == 1) {
          this.util.wechatLogin();
        } else {
          window.location.href = "/#/login/bindInfo?back=true";
        }
      };
      this.tim.on(TIM.EVENT.KICKED_OUT, onKickedOut);
      var onMessageReceived = function (event) {
        var ele = _this.$refs.chatBox;
        //判断元素是否出现了滚动条
        if (ele && event.data[0].from != "@TIM#SYSTEM") {
          if (ele.scrollHeight == ele.scrollTop + ele.clientHeight) {
            //设置滚动条到最底部
            _this.chatBox = _this.chatBox.concat(event.data);
            ele = _this.$refs.chatBox;
            setTimeout(() => {
              if (ele.scrollHeight > ele.clientHeight) {
                //设置滚动条到最底部
                ele.scrollTop = ele.scrollHeight;
              }
            }, 200);
          } else {
            _this.chatBox = _this.chatBox.concat(event.data);
          }
        }

        // event.data - 存储 Message 对象的数组 - [Message]
      };
      this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, onMessageReceived);
      var onSdkReady = function (event) {
        _this.timReady = true;
        _this.getMessge();
      };
      this.tim.on(TIM.EVENT.SDK_READY, onSdkReady);
    },
    getMessge(type) {
      var _this = this;
      if (type && _this.nextReqMessageID) {
        var nextReqMessageID = _this.nextReqMessageID;
        var promise = this.tim.getMessageList({
          conversationID: "C2C" + this.userid,
          nextReqMessageID,
          count: 15,
        });
      } else {
        var promise = this.tim.getMessageList({
          conversationID: "C2C" + this.userid,
          count: 15,
        });
      }
      promise.then(function (imResponse) {
        var messageList = imResponse.data.messageList; // 消息列表。
        _this.nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
        var isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
        if (type && _this.nextReqMessageID) {
          _this.chatBox = messageList.concat(_this.chatBox);
          _this.end = isCompleted;
        } else {
          _this.chatBox = _this.chatBox.concat(messageList);
        }
        // if (messageList.length < 15) {
        // }
        if (!(type && _this.nextReqMessageID)) {
          setTimeout(() => {
            var ele = _this.$refs.chatBox;
            //判断元素是否出现了滚动条
            if (ele.scrollHeight > ele.clientHeight) {
              //设置滚动条到最底部
              ele.scrollTop = ele.scrollHeight;
            }
          }, 200);
        } else {
          setTimeout(() => {
            var ele2 = _this.$refs.chatListBox;
            _this.$refs.chatBox.scrollTop =
              ele2.clientHeight - _this.ScrollHeight;
          });
        }
      });
    },
    login() {
      var _this = this;
      this.$post("/iart-api-message/im/userSig", {
        customerid: this.userinfo.customerid,
      }).then((res1) => {
        if (res1.code == 1) {
          var promise = _this.tim.login({
            userID: res1.data.customerid,
            userSig: res1.data.sign,
          });
          promise
            .then(function (imResponse) {
              console.log(imResponse, "登录成功"); // 登录成功
              _this.loginTim = true;
            })
            .catch(function (imError) {
              _this.loginTim = false;
              console.warn("login error:", imError); // 登录失败的相关信息
            });
        }
      });
    },
    showMessage() {
      if (this.info.livestatus == 1001 && this.info.rtmpplayurl) {
        var _this = this;
        this.send = true;
        setTimeout(function () {
          _this.$refs.inputMsg.focus(); //针对于pc端显示问题
        });
      }
    },
    sendMsg() {
      var _this = this;
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      } else {
        if (this.loginTim) {
          if (this.message.trim().length > 0) {
            var _this = this;
            //创建消息
            var message = this.tim.createTextMessage({
              to: _this.userid,
              conversationType: TIM.TYPES.CONV_C2C,
              payload: {
                text: _this.message,
              },
            });
            //发送消息
            var promise = this.tim.sendMessage(message);
            promise
              .then(function (imResponse) {
                // 发送成功
                _this.send = false;
                _this.message = "";
                var message = imResponse.data.message;
                message.avatar = _this.userinfo.headerimg;
                message.nick = _this.userinfo.nickname;
                _this.chatBox.push(message);
                setTimeout(() => {
                  var ele = _this.$refs.chatBox;
                  //判断元素是否出现了滚动条
                  if (ele.scrollHeight > ele.clientHeight) {
                    //设置滚动条到最底部
                    ele.scrollTop = ele.scrollHeight;
                  }
                }, 200);
              })
              .catch(function (imError) {
                // 发送失败
                if (JSON.stringify(imError).indexOf("beat word") != -1) {
                  _this.util.toast({ msg: "评论涉及敏感词" });
                } else if (imError.code == 10017) {
                  _this.util.toast({ msg: "您已被禁言" });
                } else {
                  _this.util.toast({ msg: JSON.stringify(imError) });
                }
              });
          } else {
          }
        } else {
          this.util.loginAgain();
        }
      }
    },
    onblur() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.chatContentBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #f4f4f7;
  display: flex;
  flex-direction: column;
  .chatBox {
    flex: 1;
    overflow: auto;
    padding: 12px 15px;
    li {
      width: 100%;
      .msgTip {
        font-size: 12px;
        line-height: 17px;
        color: rgba(45, 45, 45, 0.6);
        padding: 16px;
        background: rgba(45, 45, 45, 0.05);
        border-radius: 3px;
      }
      .chatDetail {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        .img {
          display: inline-block;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          margin-bottom: 4px;
        }
        .content {
          flex: 1;
          overflow: hidden;
          > div {
            width: 100%;
          }
          .name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 10px;
            line-height: 14px;
            color: rgba(45, 45, 45, 0.8);
          }
          .messageContent {
            margin-top: 5px;
            display: inline-block;
            overflow: hidden;
            font-size: 13px;
            line-height: 20px;
            color: rgba(45, 45, 45, 1);
            border-radius: 8px 8px 8px 2px;
            background: #ffffff;
            padding: 12px;
            word-break: break-all;
          }
        }
      }
    }

    li:not(:last-child) {
      margin-bottom: 16px;
    }
    .left {
      .chatDetail {
        .content > div {
          text-align: left;
        }
      }
      .img {
        margin-right: 8px;
      }
    }
    .right {
      .img {
        margin-left: 8px;
      }
      .chatDetail {
        .content > div {
          text-align: right;
          .messageContent {
            border-radius: 8px 8px 2px 8px;
            background: rgba(127, 134, 152, 1);
            color: #fff;
          }
        }
      }
    }
  }
  .footerBox {
    padding: 8px 16px;
    background: #fff;
    box-shadow: 0 1px 30px 10px rgba(0, 0, 0, 0.03);
    width: 100%;
    overflow: hidden;
    .sendMsg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .sendLeft {
        flex: 1;
        input {
          width: 100%;
          font-size: 14px;
          line-height: 20px;
          padding: 8px 12px;
          border-radius: 24px;
          overflow: hidden;
          color: rgba(45, 45, 45, 1);
          background: #f5f6f8;
          font-weight: 400;
        }
        input::placeholder {
          color: rgba(45, 45, 45, 0.3);
          font-size: 14px;
          line-height: 20px;
          font-weight: 400;
        }
      }
      .sendRight {
        margin-left: 12px;
        .send {
          font-size: 14px;
          line-height: 20px;
          color: #fff;
          cursor: pointer;
          display: inline-block;
          padding: 8px 16px;
          border-radius: 19px;
          text-align: center;
          background: #f62625;
        }
      }
    }
    .mute {
      font-size: 14px;
      line-height: 20px;
      padding: 14px;
      color: rgba(45, 45, 45, 0.3);
      text-align: center;
    }
  }
}
</style>